import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as ProductIcon } from "images/icons/bags-shopping.svg"
import { PermissionGroups } from "../constants"

const Products = lazy(() => import("views/Products/Products").then(m => ({ default: m.Products })))
const ShowProducts = lazy(() => import("views/Products/ShowProducts").then(m => ({ default: m.ShowProducts })))
const ViewProduct = lazy(() => import("views/Products/ViewProduct").then(m => ({ default: m.ViewProduct })))

export const productRoutes: Common.Views = [
  {
    element: <Products />,
    path: "/products",
    title: "Products",
    icon: ProductIcon,
    sortOrder: 5,
    requiredGroups: PermissionGroups.products.read,
    children: [
      {
        element: <ShowProducts />,
        path: "/products/",
        title: "Products",
        icon: ProductIcon
      },
      {
        element: <ViewProduct />,
        path: "/products/:id",
        title: "Product",
        parentPath: "/products"
      }
    ]
  }
]
